import useRedirect from "./useRedirect";

export default useRedirect;
